import { Form, Radio } from "antd";
import React from "react";
import { riskOptions } from "../../../../IpEMR/Options/dietAdviceOptions";

const ContinuedNutritionalRisk = () => {
  return (
    <>
      <Form.Item
        label="Continued Nutritional Risk"
        name={"continued_nutritional_risk"}
      >
        <Radio.Group options={riskOptions} />
      </Form.Item>
    </>
  );
};

export default ContinuedNutritionalRisk;
